import { useContext } from "react";
import { TwoFactorContext } from "./TwoFactorContext";

/**
 * Hook returning the runWith2FA(config) function from the provider. Pass an
 * axios request config; if the server replies 202/2fa_required the OTP modal
 * opens and the request is replayed with the X-2FA-Code header.
 * @returns {Function} runWith2FA(config) -> Promise resolving the final response
 */
export default function useWith2FA() {
    const ctx = useContext(TwoFactorContext);
    if (!ctx) {
        throw new Error("useWith2FA must be used within a TwoFactorProvider");
    }
    return ctx.runWith2FA;
}
